import { render, staticRenderFns } from "./customerCardChangeList.vue?vue&type=template&id=85d0ad54&scoped=true"
import script from "./customerCardChangeList.vue?vue&type=script&lang=js"
export * from "./customerCardChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d0ad54",
  null
  
)

export default component.exports